var _rect, _path, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarSynced(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 149,
    viewBox: "0 0 182 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 28.3164,
    y: 8.78711,
    width: 153.684,
    height: 121.192,
    rx: 5,
    fill: "#D4F0FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M28.3164 13.7871C28.3164 11.0257 30.555 8.78711 33.3164 8.78711H177C179.761 8.78711 182 11.0257 182 13.7871V27.432H28.3164V13.7871Z",
    fill: "#1778E1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 80.4932,
    y: 37.7891,
    width: 13.2813,
    height: 14.5016,
    fill: "#1778E1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 61.5205,
    y: 37.7891,
    width: 13.2813,
    height: 14.5016,
    fill: "#1778E1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 99.4658,
    y: 37.7891,
    width: 13.2813,
    height: 14.5016,
    fill: "#1778E1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 118.439,
    y: 37.7891,
    width: 13.2813,
    height: 14.5016,
    fill: "#1778E1"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 137.413,
    y: 37.7891,
    width: 12.3326,
    height: 14.5016,
    fill: "#1778E1"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 80.4932,
    y: 58.5078,
    width: 13.2813,
    height: 13.4658,
    fill: "#1778E1"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 99.4658,
    y: 58.5078,
    width: 13.2813,
    height: 13.4658,
    fill: "#1778E1"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 43.4951,
    y: 58.5078,
    width: 12.3326,
    height: 13.4658,
    fill: "#1778E1"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 61.5205,
    y: 58.5078,
    width: 13.2813,
    height: 13.4658,
    fill: "#1778E1"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 118.439,
    y: 58.5078,
    width: 13.2813,
    height: 13.4658,
    fill: "#1778E1"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 137.413,
    y: 58.5078,
    width: 12.3326,
    height: 13.4658,
    fill: "#1778E1"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 80.4932,
    y: 78.1895,
    width: 13.2813,
    height: 14.5016,
    fill: "#1778E1"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 99.4658,
    y: 78.1895,
    width: 13.2813,
    height: 14.5016,
    fill: "#1778E1"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 43.4951,
    y: 78.1895,
    width: 12.3326,
    height: 14.5016,
    fill: "#1778E1"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 61.5205,
    y: 78.1895,
    width: 13.2813,
    height: 14.5016,
    fill: "#1778E1"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 118.439,
    y: 78.1895,
    width: 13.2813,
    height: 14.5016,
    fill: "#1778E1"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 137.413,
    y: 78.1895,
    width: 12.3326,
    height: 14.5016,
    fill: "#1778E1"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 80.4932,
    y: 98.9023,
    width: 13.2813,
    height: 14.5016,
    fill: "#1778E1"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 99.4658,
    y: 98.9023,
    width: 13.2813,
    height: 14.5016,
    fill: "#1778E1"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 43.4951,
    y: 98.9023,
    width: 12.3326,
    height: 14.5016,
    fill: "#1778E1"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 61.5205,
    y: 98.9023,
    width: 13.2813,
    height: 14.5016,
    fill: "#1778E1"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 118.439,
    y: 98.9023,
    width: 13.2813,
    height: 14.5016,
    fill: "#1778E1"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 137.413,
    y: 98.9023,
    width: 12.3326,
    height: 14.5016,
    fill: "#1778E1"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 155.438,
    y: 37.7891,
    width: 12.3326,
    height: 14.5016,
    fill: "#1778E1"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 155.438,
    y: 58.5078,
    width: 12.3326,
    height: 13.4658,
    fill: "#1778E1"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 155.438,
    y: 78.1895,
    width: 12.3326,
    height: 14.5016,
    fill: "#1778E1"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 155.438,
    y: 98.9023,
    width: 12.3326,
    height: 14.5016,
    fill: "#1778E1"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 111.8,
    y: 0.5,
    width: 5.69199,
    height: 16.5733,
    rx: 2.84599,
    fill: "#1778E1"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 130.771,
    y: 0.5,
    width: 5.69199,
    height: 16.5733,
    rx: 2.84599,
    fill: "#1778E1"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 149.746,
    y: 0.5,
    width: 5.69199,
    height: 16.5733,
    rx: 2.84599,
    fill: "#1778E1"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 54.8789,
    y: 0.5,
    width: 5.69199,
    height: 16.5733,
    rx: 2.84599,
    fill: "#1778E1"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 73.8516,
    y: 0.5,
    width: 5.69199,
    height: 16.5733,
    rx: 2.84599,
    fill: "#1778E1"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 92.8262,
    y: 0.5,
    width: 5.69199,
    height: 16.5733,
    rx: 2.84599,
    fill: "#1778E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3164 118.5C58.3164 133.964 45.7804 146.5 30.3164 146.5C14.8524 146.5 2.31641 133.964 2.31641 118.5C2.31641 103.036 14.8524 90.5 30.3164 90.5C45.7804 90.5 58.3164 103.036 58.3164 118.5Z",
    fill: "#15A612"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3722 112.688C44.1532 111.907 44.1532 110.641 43.3722 109.86C42.5911 109.079 41.3248 109.079 40.5438 109.86L43.3722 112.688ZM26.5027 126.729L25.0885 128.144C25.8696 128.925 27.1359 128.925 27.9169 128.144L26.5027 126.729ZM21.4941 118.892C20.713 118.111 19.4467 118.111 18.6656 118.892C17.8846 119.673 17.8846 120.94 18.6656 121.721L21.4941 118.892ZM40.5438 109.86L25.0885 125.315L27.9169 128.144L43.3722 112.688L40.5438 109.86ZM18.6656 121.721L25.0885 128.144L27.9169 125.315L21.4941 118.892L18.6656 121.721ZM56.3164 118.5C56.3164 132.859 44.6758 144.5 30.3164 144.5V148.5C46.8849 148.5 60.3164 135.069 60.3164 118.5H56.3164ZM30.3164 144.5C15.957 144.5 4.31641 132.859 4.31641 118.5H0.316406C0.316406 135.069 13.7479 148.5 30.3164 148.5V144.5ZM4.31641 118.5C4.31641 104.141 15.957 92.5 30.3164 92.5V88.5C13.7479 88.5 0.316406 101.931 0.316406 118.5H4.31641ZM30.3164 92.5C44.6758 92.5 56.3164 104.141 56.3164 118.5H60.3164C60.3164 101.931 46.8849 88.5 30.3164 88.5V92.5Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarSynced);
export default __webpack_public_path__ + "static/media/calendar-synced.895f6d11.svg";
export { ForwardRef as ReactComponent };